import {Injectable} from '@angular/core';
import {Http, RequestOptions, Headers, Response} from '@angular/http';

import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import {LoginModel} from '../../authorization/login.model';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class TokenManagerService {
  public token: string;
  private userLoginURL = environment.apiUrl + '/User/Login';

  static getToken() {

    if (sessionStorage.getItem('currentUser') === null) {
      return localStorage.getItem('currentUser');
    } else {
      return sessionStorage.getItem('currentUser');
    }

  }

  static isAdmin() {
    if (sessionStorage.getItem('currentUser') === null) {
      return (localStorage.getItem('isAdmin') === 'true');
    } else {
      return (sessionStorage.getItem('isAdmin') === 'true');
    }
  }

  constructor(private http: Http) {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.token = currentUser && currentUser.token;
  }

  private handleError(error: Response | any) {
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body || JSON.stringify(body);
      errMsg = err.message;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    return Observable.throw(errMsg);
  }

  login(user: LoginModel, rememberMe: boolean) {
    const headers = new Headers({'Content-Type': 'application/json'});
    const options = new RequestOptions({headers: headers});

    return this.http.post(this.userLoginURL, user, options)
      .map((response: Response) => {
        const token = response.json() && response.json().token;
        if (token) {
          this.token = token;

          if (response.json().user.role == 3 || response.json().user.role == 4 || response.json().user.role == 5 || response.json().user.role == 6)
           return Observable.throw('Wrong email or password!');

          if (rememberMe) {
            localStorage.setItem('currentUser', JSON.stringify({token: token}));
            localStorage.setItem('isAdmin', response.json().user.isAdmin);
          } else {
            sessionStorage.setItem('currentUser', JSON.stringify({token: token}));
            sessionStorage.setItem('isAdmin', response.json().user.isAdmin);
          }

          return response;
        } else {
          return false;
        }
      })
      .catch(this.handleError);
  }

  isAuthenticated() {
    const promise = new Promise(
      (resolve, reject) => {
        resolve(TokenManagerService.getToken());
      }
    );
    return promise;
  }

  logout() {
    this.token = null;

    localStorage.removeItem('currentUser');
    localStorage.removeItem('isAdmin');

    sessionStorage.removeItem('currentUser');
    sessionStorage.removeItem('isAdmin');

  }


}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/shared/services/token-login.service.ts